import { useState } from "react";
import useStyles from "../styles";
import useValidator from "../../../hooks/useValidator";
import { httprequest } from "../../../data/api";
import { ToastContainer, toast } from "react-toastify";
import { Grid } from "@mui/material";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button";
import { Icon } from "@iconify/react";

const SUBJECTS_ENDPOINT = "/api/v1/subjects";

const CreateSubjectModal = ({ isOpen, onClose, onSuccess }) => {
  const classes = useStyles();
  const [subjectArr, setSubjectArr] = useState([""]);
  const [subjectValidator, showSubjectValidator] = useValidator();
  const [isCreating, setIsCreating] = useState(false);
  const [subjectForm, setSubjectForm] = useState({
    name: subjectArr
  });

  const handleCloseModal = () => {
    onClose();
    setSubjectArr([""]);
    setSubjectForm({ name: [""] });
  };

  const handleCreateSubjects = () => {
    if (subjectValidator.allValid()) {
      setIsCreating(true);
      httprequest
        .post(SUBJECTS_ENDPOINT, subjectForm)
        .then((res) => {
          setIsCreating(false);
          const toastId = toast.success(res?.data?.message, {
            autoClose: 3000
          });
          setTimeout(() => {
            toast.dismiss(toastId);
            if (onSuccess) onSuccess();
            window.location.reload();
          }, 3000);
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showSubjectValidator(true);
    }
  };

  const handleDeleteSubjectItem = (index) => {
    const newSubject = subjectArr.filter((_item, ind) => ind !== index);
    setSubjectArr(newSubject);
    setSubjectForm({ ...subjectForm, name: newSubject });
  };

  const AddAdditionalSubject = () => {
    const newSubject = "";
    setSubjectArr([...subjectArr, newSubject]);
    setSubjectForm({ ...subjectForm, name: [...subjectArr, newSubject] });
  };

  const handleSubjectChange = (e, index) => {
    const { value } = e.target;
    const allSubjects = [...subjectArr];
    allSubjects[index] = value;
    setSubjectArr(allSubjects);
    setSubjectForm({ ...subjectForm, name: allSubjects });
  };

  return (
    <div>
      <Modal
        title="Create Subject"
        subtitle="Create a new subject and assign a teacher to teach the subject."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {subjectArr?.map((item, index) => (
                  <div key={index}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Subject Name"
                        margin="normal"
                        required
                        placeHolder="Enter subject name"
                        inputType="text"
                        onChange={(e) => handleSubjectChange(e, index)}
                        value={item}
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      {subjectForm?.name?.length > 1 ? (
                        <p
                          className="delete-input"
                          onClick={() => {
                            handleDeleteSubjectItem(index);
                          }}
                        >
                          <Icon icon="zondicons:minus-solid" />
                          Remove this subject
                        </p>
                      ) : null}
                    </Grid>
                  </div>
                ))}
              </Grid>
              <div
                className={`${classes.mail} flex align-items-center`}
                onClick={AddAdditionalSubject}
              >
                <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                <p>Add another subject</p>
              </div>
            </Grid>
          </>
        }
        modalFooter={
          <div className={classes.modalFooterBtn}>
            <Button
              variant="primary"
              buttonSize="full"
              color="btndefault"
              buttonName="Add Subject(s)"
              onClick={handleCreateSubjects}
              isLoading={isCreating}
            />
          </div>
        }
        isopen={isOpen}
        closeModal={handleCloseModal}
      />
      <ToastContainer />
    </div>
  );
};

export default CreateSubjectModal;
